import logo from './logo.svg';
import './App.css';
import Appmain from './component/partial/AppMain';
import PublicRoute from './authentication/PublicRoute';
import PrivateRoute from './authentication/PrivateRoute';
import { Route, Routes } from 'react-router-dom';
import Login from './authentication/Login';
import EmailVerification from './authentication/EmailVerification';

function App() {
  return (
    <>
      <Routes>

        <Route path='/' element={
          // <PublicRoute>
            <Login />
          // </PublicRoute>
        } />

        <Route path='/email-verify' element={
          // <PublicRoute>
            <EmailVerification />
          // </PublicRoute>
        } />

        <Route path='/dashboard/*' element={
          // <PrivateRoute>
            <Appmain />
          // </PrivateRoute>
        } />
        
        <Route path='/sports/*' element={
          // <PrivateRoute>
            <Appmain />
          // </PrivateRoute>
        } />
        
        <Route path='/user/*' element={
          // <PrivateRoute>
            <Appmain />
          // </PrivateRoute>
        } />

        <Route path='/tournament/*' element={
          // <PrivateRoute>
            <Appmain />
          // </PrivateRoute>
        } />
        
        <Route path='/team/*' element={
          // <PrivateRoute>
            <Appmain />
          // </PrivateRoute>
        } />
        
        <Route path='/question/*' element={
          // <PrivateRoute>
            <Appmain />
          // </PrivateRoute>
        } />

        <Route path='/match/*' element={
          // <PrivateRoute>
            <Appmain />
          // </PrivateRoute>
        } />
        
        <Route path='/deposit/*' element={
          // <PrivateRoute>
            <Appmain />
          // </PrivateRoute>
        } />

      </Routes>
    </>
  );
}

export default App;
